import {Iteration} from "src/types/iterations";
import {v4 as uuid} from 'uuid';
import {Prescription} from "src/types/stats";
import { IMedication, IMedicationTransaction } from "src/logic/medication";

export const IterationTypes = {
  CASE_NOTES: 0,
  VITALS: 1,
  CLINIC_NOTES: 2
};

export const PrescriptionStatus = {
  ACTIVE: 0,
  CANCELLED: 1,
}

export const IterationStatus = {
  DRAFT: 0,
  PENDING: 1,
}

export const createSOAPNote = (patientRecordID: number, createdBy: number) => {
  return createIteration(IterationTypes.CASE_NOTES, patientRecordID, createdBy);
}

export const createClinicNote = (patientRecordID: number, createdBy: number) => {
  return createIteration(IterationTypes.CLINIC_NOTES, patientRecordID, createdBy);
}

export const createVitals = (patientRecordID: number, createdBy: number) => {
  return createIteration(IterationTypes.VITALS, patientRecordID, createdBy);
}

export const createIteration = (type: number, patientRecordID: number, createdBy: number): Iteration => {
  return {
    ID: null, // only created on server
    GUID: uuid(),
    status: IterationStatus.DRAFT,
    patientRecordID: patientRecordID,
    systemCategory: null,
    employeeID: createdBy,
    activationID: null,
    clinicalImpression: null,
    transportRecommendation: null,
    iterationNumber: null, // We'll create this on the server
    subjective: null,
    objective: null,
    MDNotes: null,
    recommendations: null,
    dateCreated: new Date().getTime(),
    presentingComplaint: null,
    bloodGlucose: null,
    bloodPressure: null,
    heartRate: null,
    temperature: null,
    thRR: null,
    saturation: null,
    MDComments: null,
    reviewComments: null,
    lastUpdate: null,
    treatmentOutcome: null,
    type: type,
    OHIsWorkRelated: null,
    OHCanReturnToWork: null,
    OHCanDoFullDuties: null,
    prescriptions: [],
  }
}

export const createPrescription = (
  iteration: Iteration,
  medication: IMedication,
  dosage: string,
  quantity: number,
  createdBy: number
): Prescription => {
  return {
    ID: null,
    GUID: uuid(),
    patientRecordID: iteration.patientRecordID,
    employeeID: createdBy,
    date: new Date().getTime(),
    medication: medication.name as string,
    dosage: dosage,
    status: PrescriptionStatus.ACTIVE,
    quantity: quantity,
    lastUpdate: null,
    medicationGUID: medication.ID as string,
    patientRecordIterationGUID: iteration.GUID,
    unit: medication.unit as string,
    transactions: []
  }
}


